// extracted by mini-css-extract-plugin
export default {"wrapper":"DescriptionTile_wrapper__TsJq9","description":"DescriptionTile_description__bCdpC"};